// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 27-09-2025

const CloseLoanAdvanceTypes = {
	/******* GET ALL LOAN ADVANCE COLLECTED MEMBERS LIST ******* */
	GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_START:
		'get_all_loan_advance_collected_members_list_start',
	GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_SUCCESS:
		'get_all_loan_advance_collected_members_list_success',
	GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_FAILURE:
		'get_all_loan_advance_collected_members_list_failure',
	GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_RESPONSE_RESET_START:
		'get_all_loan_advance_collected_members_list_response_reset_start',
	GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_RESPONSE_CHANGED:
		'get_all_loan_advance_collected_members_list_response_changed',
	/******* GET ALL LOAN ADVANCE COLLECTED MEMBERS LIST ******* */

	/******* FETCH PARTICULAR ACCOUNT NAME INFO ******* */
	FETCH_PARTICULAR_ACCOUNT_NAME_INFO_START: 'fetch_particular_account_name_info_start',
	FETCH_PARTICULAR_ACCOUNT_NAME_INFO_SUCCESS: 'fetch_particular_account_name_info_success',
	FETCH_PARTICULAR_ACCOUNT_NAME_INFO_FAILURE: 'fetch_particular_account_name_info_failure',
	FETCH_PARTICULAR_ACCOUNT_NAME_INFO_RESPONSE_RESET_START:
		'fetch_particular_account_name_info_response_reset_start',
	FETCH_PARTICULAR_ACCOUNT_NAME_INFO_RESPONSE_CHANGED:
		'fetch_particular_account_name_info_response_changed',
	/******* FETCH PARTICULAR ACCOUNT NAME INFO ******* */

	/******** GET ACCOUNT BASED ON TYPE ******** */
	GET_ACCOUNTS_BASEDON_TYPE_START: 'get_accounts_basedon_type_start',
	GET_ACCOUNTS_BASEDON_TYPE_SUCCESS: 'get_accounts_basedon_type_success',
	GET_ACCOUNTS_BASEDON_TYPE_FAILURE: 'get_accounts_basedon_type_failure',
	GET_ACCOUNTS_BASEDON_TYPE_RESPONSE_RESET_START:
		'get_accounts_basedon_type_response_reset_start',
	GET_ACCOUNTS_BASEDON_TYPE_RESPONSE_CHANGED: 'get_accounts_basedon_type_response_changed',
	/******** GET ACCOUNT BASED ON TYPE ******** */

	/****** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ****** */
	UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_START:
		'update_close_loan_advance_with_repayment_start',
	UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_SUCCESS:
		'update_close_loan_advance_with_repayment_success',
	UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_FAILURE:
		'update_close_loan_advance_with_repayment_failure',
	UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_RESET_START:
		'update_close_loan_advance_with_repayment_response_reset_start',
	UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_CHANGED:
		'update_close_loan_advance_with_repayment_response_changed',
	/****** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ****** */

	/****** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ****** */
	REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_START:
		'revert_close_loan_advance_with_repayment_start',
	REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_SUCCESS:
		'revert_close_loan_advance_with_repayment_success',
	REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_FAILURE:
		'revert_close_loan_advance_with_repayment_failure',
	REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_RESET_START:
		'revert_close_loan_advance_with_repayment_response_reset_start',
	REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_CHANGED:
		'revert_close_loan_advance_with_repayment_response_changed',
	/****** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ****** */
};

export default CloseLoanAdvanceTypes;
